import { baseApi } from "./baseApi";
import { accountUserResponse, PayloadAccountPatch, Response, UsersResponse, UsersStructure } from "@interfaces/index";

const accountApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getCuentasById: build.query<accountUserResponse, { id: string }>({
      query: ({ id }) => ({
        url: `cuentas/${id}`,
        method: "GET",
      }),
    }),
    patchCuenta: build.mutation<Response, { accountId: string; body: PayloadAccountPatch }>({
      query: ({ accountId, body }) => ({
        url: `cuentas/${accountId}`,
        method: "PATCH",
        body,
      }),
    }),
    getCuentasByUsername: build.query<UsersStructure[], { username: string }>({
      query: ({ username }) => ({
        url: `usuarios?q=username:${username}`,
        method: "GET",
      }),
      transformResponse: (response: UsersResponse) => {
       return response.data.data;
      },
    }),
  }),
});

export const { useLazyGetCuentasByIdQuery, usePatchCuentaMutation, useLazyGetCuentasByUsernameQuery } = accountApi;
